import { Route, Switch } from '@treams/treams-routes';
import { Container, Jumbo, Tabs } from '@treams/treams-ui';
import * as graphql from 'generated/graphql';
import { useTranslation } from 'react-i18next';
import ConnectorLogsContainer from '../packages/kakapo-ui-settings-application/pages/connectors/logs/ConnectorLogsContainer';

import Marketplace from './Marketplace';

import Afas from './products/Afas';
import Employes from './products/Employes';
import HR2Day from './products/HR2Day';
import Hooray from './products/Hooray';
import Loket from './products/Loket';
import Nmbrs from './products/Nmbrs';
import SDWorx from './products/SDWorx';
import Slack from './products/Slack';
import YouServe from './products/YouServe';

import IdentityProviders from './sso/IdentityProviders';

export default function Connectors() {
	const { t } = useTranslation();

	const { data } = graphql.useWorkspaceConnectorQuery();
	const hasConnectorLogs = !!data?.viewer.workspace.connector;

	return (
		<>
			<Jumbo
				title={t('settings.integrations.title')}
				description={t('settings.integrations.description')}
				footer={
					<Tabs.Container>
						<Tabs.Item
							title={t('settings.integrations.tab.overview.title')}
							path="/settings/integrations"
						/>
						{hasConnectorLogs && (
							<Tabs.Item
								title={t('settings.connectors.logs.title')}
								path="/settings/integrations/logs"
							/>
						)}
						<Tabs.Item
							title={t('settings.connectors.sso.title')}
							path="/settings/integrations/sso"
						/>
					</Tabs.Container>
				}
			/>
			<Switch>
				<Route path="/settings/integrations" exact>
					<Marketplace />
				</Route>
				<Route path="/settings/integrations/logs" exact>
					<Container py={4}>
						<ConnectorLogsContainer />
					</Container>
				</Route>
				<Route path="/settings/integrations/sso" exact>
					<Container py={4}>
						<IdentityProviders />
					</Container>
				</Route>
				<Route path="/settings/integrations/employes" exact>
					<Employes />
				</Route>
				<Route path="/settings/integrations/nmbrs" exact>
					<Nmbrs />
				</Route>
				<Route path="/settings/integrations/loket" exact>
					<Loket />
				</Route>
				<Route path="/settings/integrations/afas" exact>
					<Afas />
				</Route>
				<Route path="/settings/integrations/cobra" exact>
					<SDWorx />
				</Route>
				<Route path="/settings/integrations/hooray" exact>
					<Hooray />
				</Route>
				<Route path="/settings/integrations/slack" exact>
					<Slack />
				</Route>
				<Route path="/settings/integrations/youserve" exact>
					<YouServe />
				</Route>
				<Route path="/settings/integrations/hr2day" exact>
					<HR2Day />
				</Route>
			</Switch>
		</>
	);
}
